import { render, staticRenderFns } from "./Variant2.vue?vue&type=template&id=f9ddc686&"
import script from "./Variant2.vue?vue&type=script&lang=js&"
export * from "./Variant2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports